export default __webpack_public_path__ + "static/media/eleanor_user.18e96b78.png";